import { IElementToSimpleSapElementMapperFactory } from '../IElementToSimpleSapElementMapperFactory';
import Element, { ElementType } from '@/models/element';
import { IElementToSimpleSamElementsMapper } from '../elementToSimpleSapElementsMapper';
import { NullToSimpleSapELementMapper } from '../nullToSimpleSapElementMapper';
import { CtrBodyToSimpleSapElementMapper } from './ctrBodyToSimpleSapElementMapper';
import { CtrLegsToSimpleSapELementMapper } from './ctrLegsToSimpleSapElementMapper';

export class CtrElementToSimpleSapElementMApperFactory
    implements IElementToSimpleSapElementMapperFactory {

    private body = new CtrBodyToSimpleSapElementMapper();
    private legs = new CtrLegsToSimpleSapELementMapper();
    private null = new NullToSimpleSapELementMapper();

    public getMapperFor(element: Element): IElementToSimpleSamElementsMapper {
        if (element.type === ElementType.BODY) {
            return this.body;
        }
        if (element.type === ElementType.LEGS) {
            return this.legs;
        }
        return this.null;
    }
}